import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['associations']

  addNew(event) {
    event.preventDefault();
    const wrapper = event.currentTarget.closest('.nested-fields');
    const linkToAddAssociation = document.querySelector(`[data-associations="${this.associationsSelector}"][data-association-insertion-node]`);

    if (!wrapper || !linkToAddAssociation) { return }

    const clonedLinkToAddAssociation = this._cloneLinkToAddAssociation(wrapper, linkToAddAssociation);
    clonedLinkToAddAssociation.click();
    clonedLinkToAddAssociation.remove();
  }

  _cloneLinkToAddAssociation(wrapper, linkToAddAssociation) {
    const wrapperId = Date.now().toString();
    wrapper.setAttribute('data-cocoon-wrapper-id', wrapperId);

    const clonedLinkToAddAssociation = linkToAddAssociation.cloneNode(true);
    clonedLinkToAddAssociation.setAttribute('data-association-insertion-node', `[data-cocoon-wrapper-id="${wrapperId}"]`);
    clonedLinkToAddAssociation.setAttribute('data-association-insertion-method', 'after');
    clonedLinkToAddAssociation.classList.add('d-none');
    linkToAddAssociation.parentNode.insertBefore(clonedLinkToAddAssociation, linkToAddAssociation.nextSibling);

    return clonedLinkToAddAssociation;
  }

  get associationsSelector() {
    return this.data.get('associations');
  }
}
